import { cx } from '@linaria/core';
import { pm2ConfigStore } from '@pm2/store';
import { resets } from '@ui/css';
import { Caption } from '../atoms/Caption.js';
import { VideoComponentSelector } from '../index.selectors.js';
import { wrapperCls } from './_video-component.style.js';
import { Scrambled } from './atom.scrambled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function VideoComponentWrapper(props) {
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  let content;
  if (props.isScrambled) {
    content = /*#__PURE__*/jsx(Scrambled, {});
  } else {
    content = props.children;
  }
  return /*#__PURE__*/jsxs("section", {
    "data-component-type": VideoComponentSelector,
    className: cx("gVideo", resets.rootCls, wrapperCls, props.isScrambled && "scrambled", props.displayCaption === "above" && "captionOnTop", props.displayCaption === "below" && "captionOnBottom", audience === "Grade1To3" && "simple"),
    children: [props.displayCaption === "above" && /*#__PURE__*/jsx(Caption, {
      caption: props.caption,
      displayInternalInfoInPlayer: props.displayInternalInfoInPlayer,
      displayCaption: props.displayCaption,
      isScrambled: props.isScrambled
    }), content, props.displayCaption === "below" && /*#__PURE__*/jsx(Caption, {
      caption: props.caption,
      displayCaption: props.displayCaption,
      isScrambled: props.isScrambled,
      displayInternalInfoInPlayer: props.displayInternalInfoInPlayer
    })]
  });
}

export { VideoComponentWrapper };
//# sourceMappingURL=_video-component.js.map
